<template>
  <div v-if="store.isNewsLoading">
    <LoaderFullPage />
  </div>
  <template
    v-else-if="store.prmNewsPublications?.length || store.prmNewsLinks?.length"
  >
    <div class="news-wrapper" :class="{ zoomed: !isFollawed }">
      <div v-if="store.prmNewsPublications.length" class="column">
        <h4>Publications</h4>
        <PublicationCard
          v-for="post in store.prmNewsPublications"
          :key="post._id"
          :post="post"
        />
      </div>
      <div v-if="store.prmNewsLinks.length" class="column">
        <h4>Articles</h4>
        <div
          v-for="item in store.prmNewsLinks"
          :key="item._id || item.id_twitter"
        >
          <XArticleCard :article="item" />
        </div>
      </div>
    </div>
    <div class="pagination-wrapper">
      <PaginationElement
        :key="`${maxCount}${store.selectedPrmNewsParams.from}${store.selectedPrmNewsParams.size}`"
        :total-items="maxCount"
        :current-page="store.selectedPrmNewsParams.from"
        :items-limit="store.selectedPrmNewsParams.size"
        @change-current-page="changeCurrentPage"
      />
    </div>
  </template>

  <div v-else>
    <NoData />
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { useRoute } from "vue-router";

import LoaderFullPage from "@follaw-fr/components/reusable/molecules/LoaderFullPage.vue";
import PaginationElement from "@follaw-fr/components/reusable/atoms/PaginationElement.vue";
import NoData from "@follaw-fr/components/reusable/atoms/NoData.vue";
import PublicationCard from "@follaw-fr/components/social-media/posts/molecules/PublicationCard.vue";
import XArticleCard from "@follaw-fr/components/social-media/molecules/XArticleCard.vue";
import { usePrmStore } from "@follaw-fr/stores/prm";

const route = useRoute();
const store = usePrmStore();

const isFollawed = ref(route.fullPath.includes("follawed") ? true : false);

const maxCount = computed(() =>
  Math.max(store.publicationsCount, store.linkCount)
);

const changeCurrentPage = (from) => {
  store.selectedPrmNewsParams.from = from;
  if (isFollawed.value) {
    store.fetchFollawedPrmNews();
  } else {
    store.fetchOnePersonnalityNews(route.params._id);
  }
};
</script>

<style lang="scss" scoped>
.news-wrapper {
  display: flex;
  gap: 10px;

  .column {
    display: flex;
    flex-direction: column;
    gap: 10px;

    h3 {
      margin: 0;
    }
  }
}

.pagination-wrapper {
  grid-column: span 2;

  @container (max-width: 1100px) {
    grid-column: span 1;
  }
}
</style>
